<section
  class="toggle-form"
  [ngClass]="{ active: isAcknowledgementSliderOpen }"
>
  <div class="formwrap">
    <div class="Header">
      <h2>
        <b>Create Acknowledgement</b>
      </h2>
      <p-button
      appPreventDoubleClick
        styleClass="p-button-text"
        id="delegateSliderCloseButton"
        type="button"
        label="Close"
        (debounceClick)="closeSlider()"
      ></p-button>
    </div>
    <div class="general-container">
      <app-acknowledgement-creation
        [documentNumber]="documentNumber"
        [documentVersion]="documentVersion"
        [documentPhaseNumber]="documentPhaseNumber"
        [documentEffectiveDate]="documentEffectiveDate"
      ></app-acknowledgement-creation>
    </div>
  </div>
</section>
